(function () {
  'use strict';

  var media = window.matchMedia('(max-width: 767px)');

  function setPanel(toggle, panel, expanded, animate) {
    var from = panel.hidden ? 0 : panel.getBoundingClientRect().height;
    var fromMargin = panel.hidden ? 0 : parseFloat(window.getComputedStyle(panel).marginBottom) || 0;
    if (panel.orFooterAnimation) panel.orFooterAnimation.cancel();
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var mark = toggle.querySelector('.or-footer__toggle-mark');
    if (mark) mark.textContent = expanded ? '−' : '+';
    panel.inert = !expanded;
    if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !panel.animate) {
      panel.hidden = !expanded;
      panel.style.overflow = '';
      panel.orFooterAnimation = null;
      return;
    }
    panel.hidden = false;
    panel.style.overflow = 'hidden';
    var toMargin = expanded ? parseFloat(window.getComputedStyle(panel).marginBottom) || 0 : 0;
    var animation = panel.animate([{ height: from + 'px', marginBottom: fromMargin + 'px' }, { height: expanded ? panel.scrollHeight + 'px' : '0px', marginBottom: toMargin + 'px' }], { duration: 350, easing: 'linear', fill: 'both' });
    panel.orFooterAnimation = animation;
    animation.onfinish = function () {
      if (panel.orFooterAnimation !== animation) return;
      panel.hidden = !expanded;
      panel.style.overflow = '';
      panel.orFooterAnimation = null;
      animation.cancel();
    };
  }

  function getPanel(footer, toggle) {
    return Array.from(footer.querySelectorAll('[data-or-footer-panel]')).find(function (panel) {
      return panel.id === toggle.getAttribute('aria-controls');
    });
  }

  function syncFooter(footer) {
    var grid = footer.querySelector('.or-footer__link-grid');
    if (grid) {
      var groups = Array.from(grid.children);
      groups.forEach(function (group, index) { if (!group.dataset.orFooterOrder) group.dataset.orFooterOrder = String(index + 1); });
      groups.sort(function (left, right) { return Number(left.dataset.orFooterOrder) - Number(right.dataset.orFooterOrder); }).forEach(function (group) { grid.append(group); });
      if (media.matches) {
        var shop = grid.querySelector('[data-or-footer-group="shop"]');
        if (shop) grid.append(shop);
      }
    }
    footer.querySelectorAll('[data-or-footer-toggle]').forEach(function (toggle) {
      var panel = getPanel(footer, toggle);
      if (!panel) return;
      toggle.disabled = !media.matches;
      if (!media.matches) {
        toggle.tabIndex = -1;
        setPanel(toggle, panel, true);
        return;
      }
      toggle.tabIndex = 0;
      if (!footer.dataset.orFooterMobileReady) setPanel(toggle, panel, toggle.hasAttribute('data-or-footer-default-open'));
    });
    footer.dataset.orFooterMobileReady = media.matches ? 'true' : '';
  }

  function initializeFooter(footer) {
    if (footer.dataset.orFooterReady === 'true') {
      syncFooter(footer);
      return;
    }
    footer.dataset.orFooterReady = 'true';
    footer.querySelectorAll('[data-or-footer-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (!media.matches) return;
        var panel = getPanel(footer, toggle);
        if (!panel) return;
        setPanel(toggle, panel, toggle.getAttribute('aria-expanded') !== 'true', true);
      });
    });
    syncFooter(footer);
  }

  function initializeAll() {
    document.querySelectorAll('[data-or-footer]').forEach(initializeFooter);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();

  if (media.addEventListener) media.addEventListener('change', initializeAll);
  else media.addListener(initializeAll);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches && event.target.matches('[data-or-footer]')) initializeFooter(event.target);
    event.target.querySelectorAll('[data-or-footer]').forEach(initializeFooter);
  });
})();
